<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('table.isometric')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="isoTable"
                        :search="false"
                        :paginate="false"
                        :exportable = "false" title=""
                        :rows="isometric"
                        :columns="iso_columns"
                        >
                    </data-table>
                </b-card>

                <hr>

                <b-card :header="$t('general.welding.weld.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="weldTable"
                        :exportable="this.$store.getters.hasPermission(['project_weld'], ['read'])" title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowCloneRow="onCloneRow"
                        @rowClickCheck="onClickCheck"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        @rowClickRevision="onRevision"
                        @exportButtonClick="onExportButton"
                    >
                    </data-table>

                    <b-btn class="btn btn-dark mt-3 mr-2" @click="returnTo">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_weld')}}
                    </b-btn>

                    <b-btn class="btn btn-default mt-3" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_weld'], ['create'])">
                        <i class="fa fa-plus-circle mr-1"></i> {{$t('general.welding.weld.create_button')}}
                    </b-btn>
                </b-card>

                <div class="row mt-4">
                    <div class="col-sm-12">
                        <span v-if="this.$store.getters.hasPermission(['project_weld'], ['create']) && getData.rowData.length > 0">
                            <i class="fa fa-2x fa-clone text-default"></i> - {{$t('general.buttons.clone')}}
                        </span>
                    </div>
                </div>

                <weld-modal ref="weldModal" @done="done" :title="actionTitle"></weld-modal>
            </div>
        </div>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import WeldModal from '@/components/global/modals/WeldModal.vue';
import miniToastr from 'mini-toastr';
import http from '@/libs/http';

import Multiselect from 'vue-multiselect';

import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';

export default {
    name: 'weld',
    components: {
        DataTable,
        ConfirmDialog,
        Multiselect,
        WeldModal,
        vueDropzone: vue2Dropzone
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.welding.title'),
                    active: true
                },
                {
                    text: this.$store.state.current_iso.iso_no,
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.welding.title2'),
                    active: true
                }
            ],
            tableName: 'weld',
            tableNameTranslated: Vue.i18n.translate('general.welding.weld.title_modal'),
            row: null,
            weldTable: false,
            isoTable: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            getData: {
                rowData: []
            },
            model: {
            },
            isometric: [],

            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '130px',
                    showDeleteButton: true,
                    showEditButton: true,
                    showRevisionButton: true,
                },
                {
                    label: Vue.i18n.translate('table.weld_no'),
                    field: 'weld_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_place'),
                    field: 'weld_place',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_type'),
                    width: '115px',
                    field: 'project_setting.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_size'),
                    field: 'weld_size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_dimension'),
                    field: 'weld_dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_material'),
                    field: 'weld_material.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder1'),
                    field: 'welder1info.fullname2',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder_date_1'),
                    field: 'welder_date_1',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder2'),
                    field: 'welder2info.fullname2',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder_date_2'),
                    field: 'welder_date_2',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.wps'),
                    field: 'wps.wps',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.wpqr'),
                    field: 'wps.wpqr',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.spool_no'),
                    field: 'spool.spool_no',
                    numeric: false,
                    html: false,
                },
               {
                    label: Vue.i18n.translate('table.filler_material_a'),
                    field: 'filler_material_1_info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description_a'),
                    field: 'part1_fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material_a'),
                    field: 'material1',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_certificate_a'),
                    field: 'stock1_certificate_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_change_no_a'),
                    field: 'stock1_heat_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_manufacturer_a'),
                    field: 'stock1_manufacturer',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.filler_material_b'),
                    field: 'filler_material_2_info',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description_b'),
                    field: 'part2_fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material_b'),
                    field: 'material2',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_certificate_b'),
                    field: 'stock2_certificate_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_change_no_b'),
                    field: 'stock2_heat_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_manufacturer_b'),
                    field: 'stock2_manufacturer',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.repair'),
                    field: 'repair',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                },
                {
                    label: Vue.i18n.translate('table.rt'),
                    field: 'rt',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.vt'),
                    field: 'vt',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pt'),
                    field: 'pt',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ut'),
                    field: 'ut',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.mt'),
                    field: 'mt',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pmi'),
                    field: 'pmi',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pwht'),
                    field: 'pwht',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.bht'),
                    field: 'bht',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.at'),
                    field: 'at',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.fn'),
                    field: 'fn',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.others'),
                    field: 'others',
                    numeric: false,
                    html: false,
                },
                {
					label: Vue.i18n.translate('table.revision_date'),
					field: 'revision_date',
					numeric: false,
					html: false,
				},
                {
					label: Vue.i18n.translate('table.revision_number'),
					field: 'revision_number',
					numeric: false,
					html: false,
				},
            ],
            iso_columns: [
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'line.area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.serial_no'),
                    field: 'line.serial_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'line.line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_class'),
                    field: 'line.line_class',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.line_size'),
                    field: 'line.line_size',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.pipe_material'),
                    field: 'line.pipe_material',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.start_date'),
                    width: '105px',
                    field: 'start_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.end_date'),
                    width: '105px',
                    field: 'end_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.priority'),
                    field: 'priority',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.test_circuit_no'),
                    field: 'line.test_circuit_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.tie_in_no'),
                    field: 'line.tie_in_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.shut_down_iso'),
                    field: 'shut_down_iso',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.field_area'),
                    field: 'field_area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.work_type'),
                    field: 'work_type.key',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ndt'),
                    field: 'ndt',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.painting_code'),
                    field: 'line.painting_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.insulation_type'),
                    field: 'line.insulation_or_tracing_type',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pwht'),
                    field: 'line_pwht',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false
                }
            ]
        }
    },
    mounted() {
        this.$store.dispatch('getIsoInfo', this.$route.params.id2).then(response => {
            if (response.id) {
                this.$store.commit('SET_CURRENT_ISO', response);
                this.breadcrumbItems[3].text = this.$store.state.current_iso.iso_no ? 'Iso no: ' + this.$store.state.current_iso.iso_no + ', Page No: ' + this.$store.state.current_iso.page : '';
                this.current_iso = response;
                this.isoTable = true;
                this.isometric.push(this.current_iso);
                this.isometric.forEach(field => {
                    if((field.work_type_id == null || field.work_type_id == '')) {
                        field.work_type = { 'value': '' };
                    }

                    if (field.line.pwht != null) {
                        field['line_pwht'] = field.line.pwht;
                    }

                    if((field.line_id == null || field.line_id == '')) {
                        field.line = {
                            'line_number': '',
                            'insulation_or_tracing_type': '',
                            'painting_code': '',
                            'test_circuit_no': '',
                            'tie_in_no': ''
                        };
                    }
                });
            }
        });

        this.onLoadTable();
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            http.route('weld?project_id=' +this.$route.params.id + '&filters[drawing_id]=' + this.$route.params.id2 + '&filters[parent_weld_id]=null&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get().then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (field.project_setting == null) {
                            field.project_setting = { 
                                'value': '' 
                            };
                        }

                        if (field.weld_material == null) {
                            field.weld_material = { 
                                'value': '' 
                            };
                        }

                        if (field.welder1info == null) {
                            field.welder1info = { 
                                'fullname2': '' 
                            };
                        }

                        if (field.welder2info == null) {
                            field.welder2info = { 
                                'fullname2': '' 
                            };
                        }


                        if (field.wps == null) {
                            field.wps = {
                                'wps': '',
                                'wpqr': ''
                            };
                        }

                        if (field.spool == null) {
                            field.spool = { 
                                'spool_no': '' 
                            };
                        }
                    });
                    
                    this.breadcrumbItems[3].text = this.$store.state.current_iso.iso_no ? 'Iso no: ' + this.$store.state.current_iso.iso_no + ', Page No: ' + this.$store.state.current_iso.page : '';
                    this.getData.rowData = data;
                    this.weldTable = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        returnTo() {
            this.$router.go(-1);
        },
        done() {
            this.onLoadTable();
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.$refs.weldModal.clear();
            this.$refs.weldModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.$refs.weldModal.clear();
            this.$refs.weldModal.loadVals(row, 'edit');
            this.$refs.weldModal.show();
        },
        onCloneRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.clone') + ' ' + this.tableNameTranslated;
            this.$refs.weldModal.clear();
            this.$refs.weldModal.loadVals(row, 'clone');
            this.$refs.weldModal.show();
        },
        onRevision(row) {
            this.$router.push({name: 'weld_revisioncontrol', params: {id:this.$route.params.id, id2: row.id}});
        },
        onDeleteRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        onClickCheck (row, index, column) {
            if (row) {
                this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                var clone = Object.assign({}, row);
                clone[column.toString()] = !clone[column.toString()];
                var clone2 = {
                    repair: clone.repair,
                    weld_no: clone.weld_no,
                    weld_place: clone.weld_place,
                    weld_standard: clone.weld_standard,
                    project_setting_id: clone.project_setting_id,
                    weld_size: clone.weld_size,
                };
                let data = http.route(this.tableName + '/' + row.id).patch(clone2, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        row[column.toString()] = !row[column.toString()];
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
                this.model[column.toString()] = null;
            }
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if(response.isError == false) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        this.onLoadTable();
                        this.$refs.deleteModal.hide();
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            } else {
                this.$refs.deleteModal.hide();
            }
        },
        onExportButton() {
            http.route('weld').exportExcel({
                export: 1,
                project_id: this.$route.params.id,
                drawing_id: this.$route.params.id2,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType,
            }, 'weld.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/pages/project/welding/welds/weld.vue